import { LogErrors } from './../../LogErrors'
import { 
    GetInstructorsForCenters as DLGetInstructorsForCenters,
    GetInstructorDetails as DLGetInstructorDetails,
    GetInstructorAccessCode as DLGetInstructorAccessCode,
    ResetInstructorPassword as DLResetInstructorPassword,
    AddInstructorsBulk as DLAddInstructorsBulk,
    AcceptInstructor as DLAcceptInstructor,
    RejectInstructor as DLRejectInstructor,
    UnlinkInstructor as DLUnlinkInstructor,
    GetInstructorRequests as DLGetInstructorRequests,
    AcceptInstructorRequest as DLAcceptInstructorRequest,
    DeleteInstructorRequest as DLDeleteInstructorRequest
} from './../../DL/Leader/Instructors' //'./../../DL/Leaders/Instructors'


/**
 * Función auxiliar para obtener datos base de sesión de forma segura.
 */
const getSessionBaseData = () => {
    if (!sessionStorage.getItem('userData')) return null
    
    const userData = JSON.parse(sessionStorage.getItem('userData'))
    const token = userData?.token
    const idCenter = userData?.navigation?.center?.id
    
    if (!token || !idCenter) return null
    return { token, idCenter }
}

const GetInstructors = async () => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión expirada o inválida.' }

        const rolParam = 3 // Según tu requerimiento
        const response = await DLGetInstructorsForCenters(session.idCenter, rolParam, session.token)
        
        if (response.success) {
            return { success: true, data: response.data.instructors }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetInstructors - BL Instructors', error)
        return { success: false, message: 'Error interno al obtener instructores.' }
    }
}

const GetAccessCode = async () => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: '' }

        const rolParam = 3
        const response = await DLGetInstructorAccessCode(session.idCenter, rolParam, session.token)
        
        if (response.success) {
            return { success: true, data: response.data.instructorAccessCode }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetAccessCode - BL Instructors', error)
        return { success: false, message: 'Error interno al obtener código.' }
    }
}

const UploadInstructorsBulk = async (fileObj) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: '' }

        const response = await DLAddInstructorsBulk(session.idCenter, fileObj, session.token)
        return response // Devuelve success true/false
    } catch (error) {
        await LogErrors('UploadInstructorsBulk - BL Instructors', error)
        return { success: false, message: 'Error interno al cargar archivo.' }
    }
}

const ResetPassword = async (idInstructor) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: '' }

        const response = await DLResetInstructorPassword(session.idCenter, idInstructor, session.token)
        return response
    } catch (error) {
        await LogErrors('ResetPassword - BL Instructors', error)
        return { success: false, message: 'Error interno al resetear contraseña.' }
    }
}

const AcceptPendingInstructor = async (idInstructor) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: '' }
        return await DLAcceptInstructor(session.idCenter, idInstructor, session.token)
    } catch (error) {
        await LogErrors('AcceptPendingInstructor - BL', error)
    }
}

const RejectPendingInstructor = async (idInstructor) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: '' }
        return await DLRejectInstructor(session.idCenter, idInstructor, session.token)
    } catch (error) {
        await LogErrors('RejectPendingInstructor - BL', error)
    }
}

const UnlinkActiveInstructor = async (idInstructorToRemove, idInstructorToInheritGroups = null) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: '' }
        return await DLUnlinkInstructor(session.idCenter, idInstructorToRemove, idInstructorToInheritGroups, session.token)
    } catch (error) {
        await LogErrors('UnlinkActiveInstructor - BL', error)
    }
}

const GetInstructorRequests = async () => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión expirada o inválida.' }

        const rolParam = 3 // Rol de instructor
        const response = await DLGetInstructorRequests(session.idCenter, rolParam, session.token)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetInstructorRequests - BL Instructors', error)
        return { success: false, message: 'Error interno al obtener solicitudes.' }
    }
}

const AcceptInstructorRequest = async (idCenterUserRequest) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión expirada o inválida.' }
        const rolParam = 3
        return await DLAcceptInstructorRequest(session.idCenter, idCenterUserRequest, rolParam, session.token)
    } catch (error) {
        await LogErrors('AcceptInstructorRequest - BL Instructors', error)
        return { success: false, message: 'Error interno al aceptar la solicitud.' }
    }
}

const DeleteInstructorRequest = async (idCenterUserRequest) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión expirada o inválida.' }
        const rolParam = 3
        return await DLDeleteInstructorRequest(session.idCenter, idCenterUserRequest, rolParam, session.token)
    } catch (error) {
        await LogErrors('DeleteInstructorRequest - BL Instructors', error)
        return { success: false, message: 'Error interno al rechazar la solicitud.' }
    }
}

export { GetInstructors, GetAccessCode, UploadInstructorsBulk, ResetPassword, AcceptPendingInstructor, RejectPendingInstructor, UnlinkActiveInstructor, GetInstructorRequests, AcceptInstructorRequest, DeleteInstructorRequest };